module.exports = __webpack_public_path__ + "img/login_2_mini.fd17fd7f.png";